import React from 'react';
import './stack.scss';
import firebase from '../../assets/firebase.png';
import node from '../../assets/node.png';
import javascript from '../../assets/javascript.png';
import react from '../../assets/react.png';
import sass from '../../assets/sass.png';
import gatsby from '../../assets/gatsby.png';

function Stack(){
    return(
        <>
            <div className="row my-5 stack-main d-flex justify-content-center">
                    <div className="stack-img m-2" tabIndex="0" data-toggle="tooltip" title="javascript">
                        <img src={javascript} alt=""/>
                    </div>
                    <div className="stack-img m-2" tabIndex="0" data-toggle="tooltip" title="node.js">
                        <img src={node} alt=""/>
                    </div>
                    <div className="stack-img m-2" tabIndex="0" data-toggle="tooltip" title="Sass">
                        <img src={sass} alt=""/>
                    </div>
                    <div className="stack-img m-2" tabIndex="0" data-toggle="tooltip" title="React">
                        <img src={react} alt=""/>
                    </div>
                    <div className="stack-img m-2" tabIndex="0" data-toggle="tooltip" title="Firebase">
                        <img src={ firebase } alt=""/>
                    </div>
                    <div className="stack-img m-2" tabIndex="0" data-toggle="tooltip" title="Gatsby.js">
                        <img src={ gatsby } alt=""/>
                    </div>
            </div>
        </>
    );
};

export default Stack;